import { McpId } from './api';

/** Static tool catalogs for the mode-based access editor. Update when MCPs gain tools. */
export const MCP_TOOL_CATALOG: Record<McpId, string[]> = {
  'atlas-admin': [
    'add_actors_to_project_role',
    'add_default_actors_to_project_role',
    'add_field_to_screen_tab',
    'add_issue_comment',
    'add_issue_types_to_scheme',
    'add_permission_to_scheme',
    'add_screen_tab',
    'add_security_level_member',
    'add_worklog',
    'archive_issues',
    'archive_project',
    'assets_create_attribute',
    'assets_create_object',
    'assets_create_object_type',
    'assets_create_schema',
    'assets_create_status_type',
    'assets_delete_attribute',
    'assets_delete_object',
    'assets_delete_object_type',
    'assets_delete_schema',
    'assets_get_connected_tickets',
    'assets_get_object',
    'assets_get_object_history',
    'assets_get_object_type',
    'assets_get_schema',
    'assets_get_workspace',
    'assets_list_attributes',
    'assets_list_icons',
    'assets_list_object_types',
    'assets_list_objects',
    'assets_list_reference_types',
    'assets_list_schemas',
    'assets_list_status_types',
    'assets_search_aql',
    'assets_update_attribute',
    'assets_update_object',
    'assets_update_object_type',
    'assets_update_schema',
    'assign_issue_security_scheme',
    'assign_issue_type_scheme',
    'assign_issue_type_screen_scheme',
    'assign_workflow_scheme_to_project',
    'bulk_export_issues',
    'bulk_import_assets',
    'bulk_update_issues',
    'confluence_add_page_label',
    'confluence_create_page',
    'confluence_create_space',
    'confluence_delete_page',
    'confluence_delete_space',
    'confluence_get_page',
    'confluence_get_page_by_title',
    'confluence_get_page_labels',
    'confluence_get_space',
    'confluence_get_space_by_key',
    'confluence_list_pages',
    'confluence_list_spaces',
    'confluence_move_page',
    'confluence_remove_page_label',
    'confluence_search',
    'confluence_update_page',
    'confluence_update_space',
    'create_automation_rule',
    'create_board',
    'create_custom_field',
    'create_custom_field_context',
    'create_custom_field_options',
    'create_dashboard',
    'create_filter',
    'create_issue',
    'create_issue_link',
    'create_issue_security_scheme',
    'create_issue_type',
    'create_issue_type_scheme',
    'create_issue_type_screen_scheme',
    'create_permission_scheme',
    'create_project',
    'create_project_form',
    'create_project_role',
    'create_screen',
    'create_screen_scheme',
    'create_security_level',
    'create_sprint',
    'create_status',
    'create_workflow',
    'create_workflow_scheme',
    'create_workflow_scheme_draft',
    'delete_board',
    'delete_custom_field',
    'delete_custom_field_context',
    'delete_custom_field_option',
    'delete_dashboard',
    'delete_filter',
    'delete_issue',
    'delete_issue_security_scheme',
    'delete_issue_type',
    'delete_issue_type_scheme',
    'delete_permission_scheme',
    'delete_project',
    'delete_project_form',
    'delete_project_role',
    'delete_screen',
    'delete_screen_scheme',
    'delete_screen_tab',
    'delete_security_level',
    'delete_sprint',
    'delete_status',
    'delete_workflow',
    'delete_workflow_scheme',
    'delete_worklog',
    'disable_automation_rule',
    'enable_automation_rule',
    'export_automation_rule_by_id',
    'export_automation_rules_to_file',
    'export_automation_rules_to_git',
    'get_active_instance',
    'get_all_permissions',
    'get_asset_field_config_instructions',
    'get_automation_rule',
    'get_board',
    'get_board_configuration',
    'get_boards',
    'get_custom_field',
    'get_custom_field_contexts',
    'get_custom_field_options',
    'get_custom_fields',
    'get_dashboard',
    'get_dashboards',
    'get_default_project_role_actors',
    'get_field_configuration_items',
    'get_field_configurations',
    'get_filter',
    'get_filters',
    'get_issue',
    'get_issue_comments',
    'get_issue_link_types',
    'get_issue_security_scheme',
    'get_issue_security_schemes',
    'get_issue_type',
    'get_issue_type_schemes',
    'get_issue_type_screen_schemes',
    'get_issue_types',
    'get_issue_worklogs',
    'get_permission_scheme',
    'get_permission_scheme_grants',
    'get_permission_schemes',
    'get_project',
    'get_project_form',
    'get_project_forms',
    'get_project_permissions',
    'get_project_role',
    'get_project_role_actors',
    'get_project_roles',
    'get_request_type_form',
    'get_screen',
    'get_screen_schemes',
    'get_screen_tab_fields',
    'get_screen_tabs',
    'get_screens',
    'get_security_level_members',
    'get_sprint_issues',
    'get_sprints',
    'get_status',
    'get_statuses',
    'get_transitions',
    'get_workflow',
    'get_workflow_scheme',
    'get_workflow_schemes',
    'get_workflows',
    'jsm_add_customers_to_service_desk',
    'jsm_add_organization_to_service_desk',
    'jsm_add_request_comment',
    'jsm_add_request_participants',
    'jsm_add_users_to_organization',
    'jsm_create_customer',
    'jsm_create_organization',
    'jsm_create_request',
    'jsm_create_request_type',
    'jsm_delete_organization',
    'jsm_delete_request_type',
    'jsm_get_organization',
    'jsm_get_organization_users',
    'jsm_get_organizations',
    'jsm_get_queue',
    'jsm_get_queue_issues',
    'jsm_get_queues',
    'jsm_get_request',
    'jsm_get_request_comments',
    'jsm_get_request_participants',
    'jsm_get_request_sla',
    'jsm_get_request_transitions',
    'jsm_get_request_type',
    'jsm_get_request_type_fields',
    'jsm_get_request_type_groups',
    'jsm_get_request_types',
    'jsm_get_requests',
    'jsm_get_service_desk',
    'jsm_get_service_desk_customers',
    'jsm_get_service_desk_organizations',
    'jsm_get_service_desks',
    'jsm_remove_customers_from_service_desk',
    'jsm_remove_organization_from_service_desk',
    'jsm_remove_request_participant',
    'jsm_remove_users_from_organization',
    'jsm_transition_request',
    'link_form_to_request_type',
    'list_automation_rules',
    'list_instances',
    'list_projects',
    'move_field_on_screen_tab',
    'move_issues_to_sprint',
    'publish_workflow_scheme_draft',
    'remove_actors_from_project_role',
    'remove_default_actors_from_project_role',
    'remove_field_from_screen_tab',
    'remove_issue_type_from_scheme',
    'remove_permission_from_scheme',
    'remove_security_level_member',
    'restore_project',
    'search_issues',
    'select_instance',
    'set_project_role_actors',
    'transition_issue',
    'unarchive_issues',
    'update_automation_rule',
    'update_automation_rule_scope',
    'update_custom_field',
    'update_custom_field_options',
    'update_dashboard',
    'update_filter',
    'update_issue',
    'update_issue_security_scheme',
    'update_issue_type',
    'update_issue_type_scheme',
    'update_permission_scheme',
    'update_project',
    'update_project_form',
    'update_project_role',
    'update_screen',
    'update_screen_scheme',
    'update_screen_tab',
    'update_security_level',
    'update_sprint',
    'update_status',
    'update_workflow_scheme',
    'update_workflow_scheme_draft_issue_type',
    'update_worklog',
  ],
  'di-assets': [
    'list_assets', 'get_asset', 'search_assets', 'diff_versions', 'create_version',
    'promote_version', 'prepare_upload', 'record_usage', 'update_asset_status',
    'list_workspaces', 'get_workspace', 'create_workspace', 'update_workspace',
    'list_members', 'invite_member', 'remove_member', 'set_member_role',
  ],
  n8n: [
    'get_node', 'get_template', 'n8n_audit_instance', 'n8n_autofix_workflow',
    'n8n_create_workflow', 'n8n_delete_workflow', 'n8n_deploy_template', 'n8n_executions',
    'n8n_generate_workflow', 'n8n_get_workflow', 'n8n_health_check', 'n8n_list_workflows',
    'n8n_manage_credentials', 'n8n_manage_datatable', 'n8n_test_workflow',
    'n8n_update_full_workflow', 'n8n_update_partial_workflow', 'n8n_validate_workflow',
    'n8n_workflow_versions', 'search_nodes', 'search_templates', 'tools_documentation',
    'validate_node', 'validate_workflow',
  ],
  arl: ['bootstrap_session', 'get_adr', 'get_ca_briefing', 'get_cascade_standard', 'get_goals', 'list_adrs'],
  jev: ['Evaluate_with_Jev', 'get_my_jev_usage'],
};
